import { ButtonBS, HStack, Stack, Text } from "@biblioteksentralen/react";
import { DialogLC } from "../../../../components/ModalContainer";
import { useTranslation } from "../../../../utils/hooks/useTranslation";
import { HoldingCounts } from "../../../hooks/useHoldingCounts";
import { ReservableHolding } from "../useChosenReservableHolding";
import InternalLink from "../../../../components/InternalLink";
import { ItemCoverImage } from "../../ItemCoverImage";
import { listAsText } from "../../../../utils/listAsText";
import { formatAgentName } from "../../../cordata/agents";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  holdingCounts: HoldingCounts;
  reservableHolding: ReservableHolding;
  selectedLibrary: {
    code: string;
    name: string;
  };
  hideImage?: boolean;
};

export const ReservationSuccessModal = (props: Props) => {
  const { t, ts } = useTranslation();

  const isAvailable = props.holdingCounts.availableForLoan !== 0;
  const workTriple = props.reservableHolding.workTriple;
  const isBook = workTriple.isBook;
  const workId = workTriple.work.id;
  const isOnWaitingList = props.holdingCounts.numberOfReservations !== 0;

  return (
    <DialogLC
      heading={t("Reservasjonen din er registrert")}
      open={props.isOpen}
      onOpenChange={props.handleClose}
      modalContentProps={{ maxWidth: "30rem" }}
      footer={
        <HStack justifyContent="center" width="100%">
          {!isAvailable && isBook && (
            <ButtonBS
              as={InternalLink}
              href={`/samling/mensduventerpaa/${workId}`}
              variant="secondary"
              textDecoration="none"
            >
              {t("Se lignende bøker")}
            </ButtonBS>
          )}
          {isAvailable ? (
            <ButtonBS onClick={props.handleClose}>{t("OK")}</ButtonBS>
          ) : (
            <ButtonBS onClick={props.handleClose}>{isBook ? t("Ferdig") : t("OK")}</ButtonBS>
          )}
        </HStack>
      }
    >
      <Stack as="section" gap="2rem">
        <HStack gap="1rem" alignItems="flex-start">
          <ItemCoverImage item={workTriple} usePlaceholder={props.hideImage} maxWidth="7rem" />
          <Stack gap="0.75rem">
            <Text>
              {t("Du har reservert")} {"“"}
              {workTriple.getFormattedManifestationTitle()}
              {"”"} {t("av")}{" "}
              {listAsText(
                workTriple.work.contributors.map(({ agent }) => formatAgentName(ts, agent)),
                t("og")
              )}
              {"."}
            </Text>
            <Text>
              {t("Du får beskjed når reservasjonen er klar til henting på {libraryName}.", {
                libraryName: props.selectedLibrary.name,
              })}
            </Text>
          </Stack>
        </HStack>
        {!isAvailable && workTriple.isBook && (
          <>
            {isOnWaitingList ? (
              <Text>
                {t("Du er nummer {kø} på ventelisten, vil du lese noe annet i mellomtiden?", {
                  kø: props.holdingCounts.numberOfReservations,
                })}
              </Text>
            ) : (
              <Text display="inline-block">{t("Denne boken er ikke ledig, vil du lese noe annet i mellomtiden?")}</Text>
            )}
          </>
        )}
      </Stack>
    </DialogLC>
  );
};
